webpackJsonp([180904998783293],{

/***/ 1948:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---anatomy-babelrc-a0e39f21c11f6a62c5ab.js